<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Usuário">
        <input class="form-input" v-model="config.auth.user">
      </form-group>
      <form-group label="Senha">
        <input class="form-input" v-model="config.auth.password">
      </form-group>
      <form-group label="Email Seller">
        <input class="form-input" v-model="config.auth.email">
      </form-group>
      <form-group label="CNPJ Seller">
        <input class="form-input" v-mask="'##.###.###/####-##'" v-model="config.auth.cnpj">
      </form-group>
      <form-group label="Token" :columns="6" v-if="config.auth.accessToken">
        {{ config.auth.accessToken.substring(0, 50) }}...
        <button type="button" @click="copied()" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar" v-clipboard:copy="config.auth.accessToken">
          <i class="icon icon-copy2"></i> 
        </button>
      </form-group>
    </div>

    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <div class="l-col-6@md">
          <quotation-configuration :quotation="config.quotation" :marketplace="identifier"/>
        </div>

        <form-group label="Retorno de frete preferencial" :required="isPreferenceRequired">
          <select v-model="config.quotation.preferenceFreight" class="form-select">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option :value="preference" v-for="preference in preferences">{{ $t(`${preference}.label`) }}</option>
          </select>
          <small class="form-help">Critério para seleção do frete de exibição.</small>
        </form-group>
      </div>
    </panel>

    <panel :title="$t('order.label')">
      <div class="l-row">
        <order-retrieve-date-configuration :columns="6" :orderConfigs="config.order"/>

        <form-group label="Estimativa Entrega *" :columns="3">
          <input class="form-input" min="0" type="number" v-model="config.order.defaultEstimatedDays">
          <small class="form-help">Quantidade de dias úteis, que o sistema irá acrescentar a data de postagem. Caso queira desativar informar 0 (ZERO)</small>
        </form-group>
      </div>
    </panel>

    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados na Integracommerce.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados na Integracommerce.</small>
        </form-group>

      </div>
    </panel>

  </module-configuration>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import { getAllUrlParams } from '@/helper'
  import notifier from '@/notifier'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI', 'quotationDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'integracommerce'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'integracommerce',
      isPreferenceRequired: false,
      config: {
        auth: {
          environment: 'sandbox',
          user: null,
          password: null,
          email: null,
          cnpj: ''
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null,
          defaultEstimatedDays: 1
        },
        quotation: {
          shipmentMethod: null,
          preferenceFreight: null
        },
        synchronize: {
          stock: true,
          price: true
        }
      },
      synchronizeOptions: [
        true,
        false
      ]
    }),
    mounted () {
      if (getAllUrlParams() !== undefined) {
        if (getAllUrlParams().status !== undefined) {
          if (getAllUrlParams().status === 'success') {
            notifier.success(decodeURI(getAllUrlParams().msg), 'Salvo')
          } else {
            notifier.error(decodeURI(getAllUrlParams().errorMsg), 'Conta não encontrada')
          }
        }
      }
    },
    methods: {
      copied () {
        notifier.success('Token copiado com sucesso!', 'Sucesso')
      }
    },
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      },
      'config.quotation.shipmentMethod' (value) {
        this.isPreferenceRequired = value !== null
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled'
      ]),
      preferences () {
        return [
          'lowestPrice',
          'shorterTime'
        ]
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Integracommerce.vue?0233d009